import { Router, isAuthenticated } from './routes';
//reducers
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { finishLoadingLanguage, getDir, getLangAsync, selectedLanguage } from 'state/reducers/translation.reducers';
//MUI
import { Box } from '@mui/system';
import { ThemeProvider } from './theme';
import 'theme/fonts.css';
//compnents
import AssetsProvider from 'pages/AssetsProvider';
import React, { useEffect } from 'react';
import { getToken } from 'state/reducers/auth.reducers';
import {
	getCountries,
	getIndustries,
	getPaymentsPurpose,
	getAllowedCurrencies,
	getBankList,
	getAltshulerBankAccountList,
	setAppVersion,
} from 'services/global.service';
import { getAllCompanies } from 'services/companies.service';
import { getAllAltshulerEmployees } from 'services/companies.service';

const App: React.FC = () => {
	const dir = useAppSelector(getDir);
	const dispatch = useAppDispatch();
	const language = useAppSelector(selectedLanguage);
	const token = useAppSelector(getToken);

	useEffect(() => {
		dispatch(getLangAsync(language));
	}, []);

	useEffect(() => {
		if (isAuthenticated(token)) {
			dispatch(getAllowedCurrencies());
			dispatch(getCountries());
			dispatch(getIndustries());
			dispatch(getBankList());
			dispatch(getAllAltshulerEmployees());
			dispatch(getAllCompanies());
			dispatch(getAltshulerBankAccountList());
			dispatch(setAppVersion());
			dispatch(getPaymentsPurpose());
		}
	}, [token]);

	return (
		<ThemeProvider dir={dir}>
			<AssetsProvider />
			<Box dir={dir} sx={{ overflowY: 'auto' }}>
				{<Router token={token} />}
			</Box>
		</ThemeProvider>
	);
};
export default App;
